import { _ as _isFunction } from './_Map-9acd9da3.js';
import { _ as _isNull, a as _isUndefined } from './isNull-db706d68.js';
import { c as chain } from './chain-d06384bf.js';

var chainedRender = function chainedRender(defaultRender, customRender) {
  for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    params[_key - 2] = arguments[_key];
  }

  return chain(function (element) {
    return !_isNull(element) && !_isUndefined(element);
  }, function () {
    return customRender && _isFunction(customRender) && customRender.apply(void 0, params);
  }, function () {
    return defaultRender.apply(void 0, params);
  });
};

export { chainedRender as c };
